export default __webpack_public_path__ + "static/media/congratulationIcon.2f1f5a95.png";